<template>
  <ApolloMutation
    :mutation="(gql) => deleteChapterQuery"
    :variables="{
      chapterId: chapter.id,
    }"
    :update="updateCache"
  >
    <template v-slot="{ mutate, loading }">
      <v-btn
        class="rounded-xl ml-1 mt-3 white--text pa-3"
        small
        :elevation="0"
        color="secondaryAction"
        @click="
          confirmDeletion(
            mutate.bind({
              refetchQueries: ['GetStoryWithChapters'],
            })
          )
        "
        :disabled="loading"
        :loading="loading"
      >
        <v-icon>mdi-delete</v-icon
        >{{ $t("storyHub.chapterList.deleteChapter") }}</v-btn
      >
      <DeleteConfirmationModal :deleteGuardNamespace="deleteGuardNamespace" />
    </template>
  </ApolloMutation>
</template>
<script>
import { chapterQueries } from "@/graphql/ChapterQueries";
import confirmDialog from "@/store/modules/confirmDialog";
import DeleteConfirmationModal from "@/components/DeleteConfirmationModal";
import store from "@/store/index";
var randomBytes = require("randombytes");
const DELETE_GUARD_NAMESPACE = "deleteGuard-" + randomBytes(16).toString("hex");
export default {
  props: {
    chapter: Object,
  },
  components: {
    DeleteConfirmationModal,
  },
  created() {
    store.registerModule(DELETE_GUARD_NAMESPACE, confirmDialog);
    this.$store.commit(`${DELETE_GUARD_NAMESPACE}/setType`, "chapter");
  },
  beforeDestroy() {
    store.unregisterModule(DELETE_GUARD_NAMESPACE);
  },
  methods: {
    updateCache(
      store,
      {
        data: {
          deleteChapter: { chapter },
        },
      }
    ) {
      for (const chapterConnector of this.chapter.chapterConnectors) {
        const normalizedId = store.identify({
          id: chapterConnector.id,
          __typename: "ChapterConnector",
        });
        store.evict({ id: normalizedId });
      }
      for (const chapterConnector of this.chapter.chapterConnectorsTo) {
        const normalizedId = store.identify({
          id: chapterConnector.id,
          __typename: "ChapterConnector",
        });
        store.evict({ id: normalizedId });
      }
      store.modify({
        id: store.identify(this.chapter.story),
        fields: {
          chapters(existingChapterRefs, { readField }) {
            return existingChapterRefs.filter(
              (chapterRef) => chapter.id !== readField("id", chapterRef)
            );
          },
        },
      });
    },
    confirmDeletion(mutate) {
      this.$store.dispatch(`${DELETE_GUARD_NAMESPACE}/show`, {
        callback: mutate,
      });
    },
  },
  computed: {
    deleteChapterQuery() {
      return chapterQueries.deleteChapter;
    },
    deleteGuardNamespace() {
      return DELETE_GUARD_NAMESPACE;
    },
  },
};
</script>

